module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-signup-page"
  }, [(_vm.showSignedInBanner) ? _c('div', {
    staticClass: "sk-signed-in-banner"
  }, [_vm._v("\n    You're signed in as "), _c('strong', [_vm._v(_vm._s(_vm.$root.userEmail))]), _vm._v(".\n    "), _c('button', {
    staticClass: "sk-signed-in-logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logoutSignedIn
    }
  }, [_vm._v("Log out")]), _vm._v("\n    to create a different account.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-topbar sk-topbar-split"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "sk-topbar-login",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Already a customer? "), _c('b', [_vm._v("Log in")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-steps-bar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sk-step-connector"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-step",
    class: {
      'sk-step-done': _vm.finishMode
    }
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v(_vm._s(_vm.finishMode ? '✓' : '2'))]), _vm._v("\n      Connect Amazon "), _c('small', {
    staticClass: "sk-step-time"
  }, [_vm._v("· ~1 min")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main-wide"
  }, [_c('div', {
    staticClass: "sk-two-col-card"
  }, [_c('div', {
    staticClass: "sk-trust-panel",
    class: {
      'sk-trust-panel-asgtg': _vm.isAsgtg,
      'sk-story': !_vm.isAsgtg
    }
  }, [(_vm.isAsgtg) ? [_c('span', {
    staticClass: "sk-panel-badge"
  }, [_vm._v("ASGTG Partner Offer")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "sk-panel-h sk-asgtg-h"
  }, [_vm._v("Every signal on your Amazon listings — Buy Box, fees, suppression, stock, rank and more.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-panel-sub"
  }, [_vm._v("Built for sellers who found SentryKit through ASGTG. Real-time alerts the moment something changes, so problems get caught before they compound.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-asgtg-signals-lead"
  }, [_vm._v("50+ signals across nine groups — every one of them on every plan.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)] : [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sk-feed",
    attrs: {
      "aria-label": "Example alerts"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sk-alert"
  }, [_c('span', {
    staticClass: "sk-alert-ic sk-alert-ic-bb",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 7h16l-1.5 11a2 2 0 0 1-2 1.7H7.5a2 2 0 0 1-2-1.7L4 7z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M9 7a3 3 0 0 1 6 0",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "sk-alert"
  }, [_c('span', {
    staticClass: "sk-alert-ic sk-alert-ic-tx",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 20h4L19 9l-4-4L4 16v4z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "sk-alert sk-alert-dim"
  }, [_c('span', {
    staticClass: "sk-alert-ic sk-alert-ic-fee",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3S9.5 10.4 12 11s4.5 1.6 4.5 3.5-2 3-4.5 3-4.5-1.3-4.5-3",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('section', {
    staticClass: "sk-voices",
    attrs: {
      "aria-labelledby": "sk-voices-h"
    },
    on: {
      "mouseenter": _vm.pauseVoices,
      "mouseleave": _vm.resumeVoices,
      "focusin": _vm.pauseVoices,
      "focusout": _vm.resumeVoices
    }
  }, [_c('div', {
    staticClass: "sk-voices-head"
  }, [_c('h3', {
    attrs: {
      "id": "sk-voices-h"
    }
  }, [_vm._v("What sellers tell us")]), _vm._v(" "), _c('div', {
    staticClass: "sk-voices-tabs",
    attrs: {
      "role": "tablist",
      "aria-label": "What sellers mention"
    }
  }, _vm._l((_vm.voices), function(v, k) {
    return _c('button', {
      key: v.tab,
      attrs: {
        "type": "button",
        "role": "tab",
        "aria-selected": k === _vm.voiceIndex ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.selectVoice(k)
        }
      }
    }, [_vm._v(_vm._s(v.tab))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sk-voices-stage"
  }, _vm._l((_vm.voices), function(v, k) {
    return _c('figure', {
      key: v.tab,
      staticClass: "sk-voice",
      class: {
        on: k === _vm.voiceIndex
      },
      attrs: {
        "role": "tabpanel"
      }
    }, [(v.ours) ? _c('p', {
      staticClass: "sk-voice-promise"
    }, [_vm._v(_vm._s(v.text))]) : _c('blockquote', [_vm._v("\"" + _vm._s(v.text) + "\"")]), _vm._v(" "), _c('figcaption', {
      class: {
        ours: v.ours
      }
    }, [_vm._v(_vm._s(v.who))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sk-voices-bar",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    key: _vm.voiceCycle,
    class: {
      run: !_vm.voicePaused && !_vm.reduceMotion
    }
  })]), _vm._v(" "), _vm._m(13)])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sk-form-panel"
  }, [(_vm.finishMode) ? [_c('div', {
    staticClass: "sk-amz-connected"
  }, [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Amazon connected"), (_vm.pendingAmazon) ? [_vm._v(": " + _vm._s(_vm.pendingAmazon.marketplaceCount) + " " + _vm._s(_vm.pendingAmazon.marketplaceCount === 1 ? 'marketplace' : 'marketplaces') + " in " + _vm._s(_vm.regionLabel(_vm.pendingAmazon.region)))] : _vm._e()], 2), _vm._v(" "), _c('h1', [_vm._v("Finish setting up")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v("Add your email, name and password.")])] : _c('h1', [_vm._v("Start your 14-day free trial")]), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "sk-offer"
  }, [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16)]) : _vm._e(), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "sk-perks"
  }, [_c('div', {
    staticClass: "sk-perk"
  }, [_c('span', {
    staticClass: "sk-perk-ic",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "8",
      "r": "3.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.5 20c.6-3.4 3.3-5.5 6.5-5.5s5.9 2.1 6.5 5.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 4.6a3.5 3.5 0 0 1 0 6.8M18.5 14.8c1.6.8 2.7 2.6 3 5.2"
    }
  })])]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('div', {
    staticClass: "sk-perk"
  }, [_c('span', {
    staticClass: "sk-perk-ic",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 12a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.4A8.5 8.5 0 1 1 21 12z"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 12h.01M12 12h.01M15.5 12h.01"
    }
  })])]), _vm._v(" "), _vm._m(18)])]) : _vm._e(), _vm._v(" "), (_vm.isAsgtg) ? _c('div', {
    staticClass: "sk-via-asgtg"
  }, [_c('span', [_vm._v("✓")]), _vm._v(" Signing up via "), _c('b', [_vm._v("ASGTG")]), _vm._v(" — your member offer is already applied.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg",
    attrs: {
      "role": "alert"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSso) ? _c('div', {
    staticClass: "sk-sso"
  }, [_c('span', {
    staticClass: "sk-field-label"
  }, [_vm._v("Sign up with")]), _vm._v(" "), _c('div', {
    staticClass: "sk-sso-row"
  }, [(_vm.googleSignupEnabled) ? _c('button', {
    staticClass: "sk-sso-google",
    attrs: {
      "type": "button",
      "aria-label": "Sign up with Google"
    },
    on: {
      "click": _vm.startGoogleSignup
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 48 48",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFC107",
      "d": "M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FF3D00",
      "d": "M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#4CAF50",
      "d": "M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#1976D2",
      "d": "M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"
    }
  })]), _vm._v("\n              Google\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showAmazon) ? _c('button', {
    staticClass: "sk-sso-amz",
    class: {
      loading: _vm.amazonWorking
    },
    attrs: {
      "type": "button",
      "aria-busy": _vm.amazonWorking ? 'true' : 'false',
      "aria-label": "Sign up with Amazon"
    },
    on: {
      "click": _vm.startAmazonSignup
    }
  }, [(_vm.amazonWorking) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('img', {
    staticClass: "sk-amz-logo",
    attrs: {
      "src": _vm.amazonWordmark,
      "alt": "Amazon"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.showAmazon) ? _c('div', {
    staticClass: "sk-region-pick"
  }, [(!_vm.showRegionPicker) ? _c('button', {
    staticClass: "sk-link-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showRegionPicker = true
      }
    }
  }, [_vm._v("Selling outside North America?")]) : _c('label', {
    staticClass: "sk-region-select"
  }, [_c('span', [_vm._v("Amazon region")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amazonRegion),
      expression: "amazonRegion"
    }],
    staticClass: "sk-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amazonRegion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.amazonRegions), function(r) {
    return _c('option', {
      key: r.value,
      domProps: {
        "value": r.value
      }
    }, [_vm._v(_vm._s(r.label))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-or"
  }, [_vm._v("or sign up with email")])]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": "",
      "autocomplete": "on"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signup.apply(null, arguments)
      },
      "focusin": _vm.onSignupFormStarted
    }
  }, [_c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.email
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-email"
    }
  }, [_vm._v("Work email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.email
    },
    attrs: {
      "id": "signup-email",
      "type": "email",
      "name": "email",
      "inputmode": "email",
      "autocomplete": "email",
      "autocapitalize": "off",
      "spellcheck": "false",
      "placeholder": "you@yourbrand.com",
      "aria-invalid": _vm.fieldErrors.email ? 'true' : 'false'
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('email')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.onEmailInput]
    }
  }), _vm._v(" "), (_vm.fieldErrors.email) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Enter a valid email address, like name@company.com.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.name
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-name"
    }
  }, [_vm._v("Your name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    ref: "name",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.name
    },
    attrs: {
      "id": "signup-name",
      "type": "text",
      "name": "name",
      "autocomplete": "name",
      "placeholder": "First and last name",
      "aria-invalid": _vm.fieldErrors.name ? 'true' : 'false'
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('name')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }, function($event) {
        return _vm.onInput('name')
      }]
    }
  }), _vm._v(" "), (_vm.fieldErrors.name) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Tell us what to call you.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.password
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.password
    },
    attrs: {
      "id": "signup-password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "At least 8 characters",
      "aria-describedby": "signup-pw-hint",
      "aria-invalid": _vm.fieldErrors.password ? 'true' : 'false',
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('password')
      },
      "input": function($event) {
        return _vm.onInput('password')
      },
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.password
    },
    attrs: {
      "id": "signup-password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "At least 8 characters",
      "aria-describedby": "signup-pw-hint",
      "aria-invalid": _vm.fieldErrors.password ? 'true' : 'false',
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('password')
      },
      "input": function($event) {
        return _vm.onInput('password')
      },
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.password
    },
    attrs: {
      "id": "signup-password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "At least 8 characters",
      "aria-describedby": "signup-pw-hint",
      "aria-invalid": _vm.fieldErrors.password ? 'true' : 'false',
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('password')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.onInput('password')
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button",
      "aria-label": _vm.showPassword ? 'Hide password' : 'Show password',
      "aria-pressed": _vm.showPassword ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])]), _vm._v(" "), (_vm.fieldErrors.password) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Use 8+ characters with a letter and a number or symbol.")]) : _c('div', {
    staticClass: "sk-pw-hint",
    class: {
      met: _vm.password && !_vm.passwordWeak
    },
    attrs: {
      "id": "signup-pw-hint"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.password && !_vm.passwordWeak ? '✓' : '○'))]), _vm._v(" At least 8 characters\n            ")])]), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.accountType
    }
  }, [_c('span', {
    staticClass: "sk-field-label",
    attrs: {
      "id": "signup-seller-type-label"
    }
  }, [_vm._v("What kind of seller are you?")]), _vm._v(" "), _c('div', {
    staticClass: "sk-seg",
    attrs: {
      "role": "radiogroup",
      "aria-labelledby": "signup-seller-type-label"
    }
  }, [_vm._l((_vm.sellerTypes), function(opt, k) {
    return [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.accountType),
        expression: "accountType"
      }],
      key: opt.value + '-input',
      ref: k === 0 ? 'accountType' : null,
      refInFor: true,
      attrs: {
        "id": 'signup-st-' + opt.value,
        "type": "radio",
        "name": "accountType"
      },
      domProps: {
        "value": opt.value,
        "checked": _vm._q(_vm.accountType, opt.value)
      },
      on: {
        "change": [function($event) {
          _vm.accountType = opt.value
        }, function($event) {
          return _vm.onInput('accountType', true)
        }]
      }
    }), _vm._v(" "), _c('label', {
      key: opt.value + '-label',
      attrs: {
        "for": 'signup-st-' + opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])]
  })], 2), _vm._v(" "), (_vm.fieldErrors.accountType) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Pick the one closest to you. It tailors your alerts.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "sk-input",
    attrs: {
      "id": "signup-company",
      "type": "text",
      "name": "organization",
      "autocomplete": "organization",
      "placeholder": "e.g. Acme Brands LLC"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sk-cta-btn",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "aria-busy": _vm.working ? 'true' : 'false'
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : (_vm.finishMode) ? _c('span', [_vm._v("Finish & start syncing →")]) : _c('span', [_vm._v("Create account & continue →")])]), _vm._v(" "), _vm._m(20)]), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "sk-next-note"
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5l8-3z",
      "stroke": "#1E9E6A",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 12l2.5 2.5 4.5-5",
      "stroke": "#1E9E6A",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.chatAvailable) ? _c('div', {
    staticClass: "sk-form-footer"
  }, [_vm._v("\n          Questions first? "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openChat.apply(null, arguments)
      }
    }
  }, [_vm._v("Chat with us")])]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-step sk-step-active"
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v("1")]), _vm._v("\n      Create account "), _c('small', {
    staticClass: "sk-step-time"
  }, [_vm._v("· ~1 min")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-asgtg-rating"
  }, [_c('span', {
    staticClass: "sk-asgtg-stars"
  }, [_vm._v("★★★★★")]), _vm._v(" "), _c('b', [_vm._v("4.8/5")]), _vm._v(" · "), _c('span', {
    staticClass: "sk-asgtg-trust"
  }, [_vm._v("Trusted by 3,000+ Amazon brands")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-asgtg-grid"
  }, [_c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("01")]), _vm._v("Fees & margin")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("02")]), _vm._v("Buy Box & pricing")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("03")]), _vm._v("Account health & policy")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("04")]), _vm._v("Listing health & suppression")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("05")]), _vm._v("Product content & fields")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("06")]), _vm._v("Reviews & feedback")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("07")]), _vm._v("Rank & visibility")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("08")]), _vm._v("Inventory & fulfilment")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("09")]), _vm._v("Competitors & hijackers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-panel-reviews"
  }, [_c('div', {
    staticClass: "sk-asgtg-review"
  }, [_c('div', {
    staticClass: "sk-asgtg-stars sk-asgtg-quote-stars"
  }, [_vm._v("★★★★★")]), _vm._v(" "), _c('p', {
    staticClass: "sk-review-text"
  }, [_vm._v("\"Reliable and powerful. The alerts land immediately — it catches everything across our catalogue without us having to check anything manually.\"")]), _vm._v(" "), _c('span', {
    staticClass: "sk-review-who"
  }, [_vm._v("Maximilian A. · Founder, Small Business · G2")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-review"
  }, [_c('div', {
    staticClass: "sk-asgtg-stars sk-asgtg-quote-stars"
  }, [_vm._v("★★★★★")]), _vm._v(" "), _c('p', {
    staticClass: "sk-review-text"
  }, [_vm._v("\"The timeliness of notifications and the detail of 'before/after' changes. Excellent customer support.\"")]), _vm._v(" "), _c('span', {
    staticClass: "sk-review-who"
  }, [_vm._v("Verified User · Small Business · G2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sk-eyebrow"
  }, [_vm._v("Amazon listing & account monitoring")]), _vm._v(" "), _c('h2', {
    staticClass: "sk-story-h"
  }, [_vm._v("See every change to your Amazon listings the moment it happens.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-story-sub"
  }, [_vm._v("Buy Box, hijackers, suppressions, fees, title and image edits. Sent to Email, Slack, Teams or ClickUp, wherever your team already works.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-feed-head"
  }, [_c('span', [_vm._v("What your alerts look like")]), _c('span', {
    staticClass: "sk-live"
  }, [_c('i'), _vm._v("Monitoring")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-alert-t"
  }, [_vm._v("Buy Box lost")]), _c('div', {
    staticClass: "sk-alert-d"
  }, [_vm._v("An unknown seller took it at "), _c('b', [_vm._v("$24.99")]), _vm._v(". Your offer: $26.49.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-alert-m"
  }, [_c('span', {
    staticClass: "sk-alert-ch"
  }, [_vm._v("Slack")]), _c('br'), _vm._v("just now")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-alert-t"
  }, [_vm._v("Title changed")]), _c('div', {
    staticClass: "sk-alert-d"
  }, [_c('s', [_vm._v("Turmeric Curcumin Capsules, 120 Count")]), _c('br'), _c('b', [_vm._v("Turmeric Capsules, 60 Count")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-alert-m"
  }, [_c('span', {
    staticClass: "sk-alert-ch"
  }, [_vm._v("Email")]), _c('br'), _vm._v("4 min ago")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-alert-t"
  }, [_vm._v("FBA fee increased")]), _c('div', {
    staticClass: "sk-alert-d"
  }, [_vm._v("+$0.61 per unit. Amazon moved this item to a new size tier.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-alert-m"
  }, [_c('span', {
    staticClass: "sk-alert-ch"
  }, [_vm._v("Teams")]), _c('br'), _vm._v("1 h ago")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-feed-foot"
  }, [_vm._v("Before and after on every change, across "), _c('b', [_vm._v("50+ signals")]), _vm._v(" per listing.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sk-voices-foot"
  }, [_vm._v("From customer emails to our team. Sellers across the US, UK, Italy, Germany, Austria and beyond. "), _c('a', {
    attrs: {
      "href": "https://www.g2.com/products/sentrykit/reviews",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Public reviews on G2 →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" No credit card")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Full access to every alert")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Cancel anytime")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-perk-t"
  }, [_vm._v("Dedicated onboarding")]), _c('div', {
    staticClass: "sk-perk-d"
  }, [_vm._v("For every account, every plan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-perk-t"
  }, [_vm._v("Immediate support")]), _c('div', {
    staticClass: "sk-perk-d"
  }, [_vm._v("Real people, anytime you need us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "signup-company"
    }
  }, [_vm._v("Company "), _c('span', {
    staticClass: "sk-opt"
  }, [_vm._v("Optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sk-legal"
  }, [_vm._v("By creating an account you agree to SentryKit's "), _c('a', {
    attrs: {
      "href": "https://www.sentrykit.com/terms",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://www.sentrykit.com/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Next: connect Amazon.")]), _vm._v(" You approve access on Amazon's own Seller Central screen, so we never see your password. SentryKit doesn't edit your listings, prices or inventory.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5467dc7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/SignupPage.vue
// module id = 776
// module chunks = 2